import http from 'plugins/axios';

export default {
  getNoticeList(data) {
    return http.get({
      url: '/la/admin/notice/list',
      data
    });
  },
  createNotice(data) {
    return http.post({
      url: '/la/admin/notice/create',
      data
    });
  },
  updateNotice(data) {
    return http.post({
      url: '/la/admin/notice/update',
      data
    });
  },
  removeNotice(id) {
    return http.post({
      url: '/la/admin/notice/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  enableNotice(id) {
    return http.post({
      url: '/la/admin/notice/enable',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  disableNotice(id) {
    return http.post({
      url: '/la/admin/notice/disable',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
